import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {Cached,LastPage,AllInclusive,Add,MoreVert,Schedule,Block,Edit,Delete,Place,WbIncandescentOutlined,ArrowDropDown,DevicesOtherOutlined,AccountBalanceWalletOutlined,ConfirmationNumberOutlined,Close, Filter,FilterList} from '@material-ui/icons';


import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  LinearProgress,
  FormHelperText,
  CircularProgress,
  Grid,
  Chip,
  Link,
  Slide
} from "@material-ui/core";

import { withLocalize,Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";

import { useSnackbar } from 'notistack';
import { setDayWithOptions } from 'date-fns/fp';

import Format from "date-fns/format";

import UserInfo from "./login_info";

import axios from 'axios';

import {TransportService,ReportingService,groupBy} from "./../../utils/web_config_2";
import { set } from 'date-fns/esm';


import DateFnsUtils from "@date-io/date-fns";

import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import iTicket from "../../assets/svg/ticket.svg"

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",

  },
  formTitle:{
    flexGrow:1,
},paper: {
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  height:120,
  elevation:0
},appBar: {
  position: 'relative',
},title: {
  marginLeft: theme.spacing(2),
  flex: 1,
}
}));




function BusinessOverview() {
  const classes = useStyles1();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();


  const [operatorData, setOperatorData] = useState({});

  const [overviewMessage,setOverviewMessage]=useState("Loading...");


  // overview  table 


const columns = [
  {
    name: "route_name",
    label: "Route",
    options: {
     filter: true,
     sort: true,
     display:true,
     customBodyRender: (value, tableMeta, updateValue) => {
      return (<Typography color="primary"><Link href="#" onClick={()=>{
        setRoute(value);
        get_details_report(value);
      }}>
        {value}
      </Link>
      </Typography>
      );
   }
    }
   },
  
  {
   name: "pos",
   label: "POS",
   options: {
    filter: true,
    sort: false,
   }
  },
  {
   name: "validator",
   label: "Validator",
   options: {
    filter: true,
    sort: false,
   }
  }, {
    name: "kiosk",
    label: "KIOSK",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "ussd",
    label: "USSD",
    options: {
     filter: true,
     sort: true,
    }
   },  
   {
    name: "app_web",
    label: "APP/WEB",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "total_tickets",
    label:"Total Tickets",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "amount",
    label: "Total income",
    options: {  
     filter: true,
     sort: true,
    }
   }
 ];



 const options = {
  textLabels: {
    body: {
      noMatch: overviewMessage
    },
  },
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 10,
   elevation:0
 };





  useEffect(()=>{

    var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);
    }

    setOperatorData(data);
    axios.defaults.baseURL = new TransportService().BASE_URL;

    // get_report(data.token,"first",Format(new Date(), ["yyyy-MM-dd",]));


    get_branch_report(data.token);
    
    
    // set_interval(data.token,Format(new Date(), ["yyyy-MM-dd",]));

   

  },[]);

  const [day,setDay]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
  // business overview

  const [totalTickets,setTotalTickets]=useState(0);
  const [totalAmount,setTotalAmount]=useState(0);

  const [reports,setReports]=useState([]);
  const [reportLoad,setReportLoad]=useState(false);


  const get_report=(token,status,d)=>{
    let data={};
    if(status=="first"){
      data={
        "route": "",
        "day":d,
        "organization_id":new UserInfo().ORG_ID
    };
      setReportLoad(true);
    }else{
      data={
        "route": "",
        "day":d,
        "organization_id":new UserInfo().ORG_ID
    };

    }
    axios.defaults.baseURL = new ReportingService().BASE_URL;
    const reportInstance = axios.create(new ReportingService().setHeaders(token));
    reportInstance.post('/pos-report/route-daily-ticket',data)
  .then(res=>{

    if(status=="second"){
      if(d==Format(new Date(), ["yyyy-MM-dd",])){
        var objs=res.data.data;
        if(objs.length==0){
          setOverviewMessage("No report available!");
        }
        var totT=0;
        var totA=0;
        objs.map((o)=>{
        o['pos']=o['total_tickets'];
        o['validator']=0;
        o['app']=0;
        o['kiosk']=0;
        var t=parseInt(o['total_amount']);
        totA=totA+parseInt(o['total_amount']);
        o['total_amount']=formatMoney(t,0)+" "+o['currency'];
        totT=totT+parseInt(o['total_tickets']);
       
        });
        setTotalTickets(totT);
        setTotalAmount(totA);
        setReports(objs);
        setReportLoad(false);



      }
    }else{

      var objs=res.data.data;
      if(objs.length==0){
        setOverviewMessage("No report available!");
      }
      var totT=0;
      var totA=0;
      objs.map((o)=>{
      o['pos']=o['total_tickets'];
      o['validator']=0;
      o['app']=0;
      o['kiosk']=0;
      var t=parseInt(o['total_amount']);
      totA=totA+parseInt(o['total_amount']);
      o['total_amount']=formatMoney(t,0)+" "+o['currency'];
      totT=totT+parseInt(o['total_tickets']);
     
      });
      
      setTotalTickets(totT);
      setTotalAmount(totA);
      setReports(objs);
      setReportLoad(false);
    }


  })
  .catch(err=>{
    setReportLoad(false);
  });

  }


  // report by channel 

  const [groupedByCurrency, setGroupedByCurrency ]= useState([]);

  const get_branch_report=(token)=>{

    axios.defaults.baseURL = new ReportingService().BASE_URL;
    const reportInstance = axios.create(new ReportingService().setHeaders(token));
    reportInstance.post('/pos-report/branch-detail-report',
    {
      "company_id": ""+new UserInfo().ORG_ID+"",
      "end_date": Format(new Date(), ["yyyy-MM-dd",]),
      "start_date": Format(new Date(), ["yyyy-MM-dd",])
    }
    
    )
    .then(res=>{

      let tot_amount=0;
      let tot_tickets=0;
    
var obj=res.data.data;
if(obj.length==0)setDetailsMessage("NO report available");

  var groupByCurrency = groupBy(obj, function (item) {
    return [item.currency];
  });
  setGroupedByCurrency(groupByCurrency);

obj.map((o)=>{

  tot_amount+=o['total_income'];
  tot_tickets+=o['total_tickets'];
  o['total_amount']= formatMoney(o['total_income'],0)

});


    var groupByRoute = groupBy(obj, function(item) {
      return [item.route_name,item.currency];
    });

    var routeGroup=[];

    groupByRoute.map((o)=>{

      var routes=o;

      var route=routes[0]['route_name'];
      // total amount

    var total_amount=routes.reduce(function (sum, amount) {
        return sum + parseInt(amount.total_income);
    }, 0);

      // total tickets 
    var total_tickets=routes.reduce(function (sum, tickets) {
      return sum + parseInt(tickets.total_tickets);
    }, 0);

    var pos=routes.reduce(function (sum, tickets) {
      return sum + parseInt(tickets.pos);
    }, 0);

    var validator=routes.reduce(function (sum, tickets) {
      return sum + parseInt(tickets.validator);
    }, 0);
    var kiosk=routes.reduce(function (sum, tickets) {
      return sum + parseInt(tickets.kiosk);
    }, 0);

    var app_web=routes.reduce(function (sum, tickets) {
      return sum + parseInt(tickets.app_web);
    }, 0);
    var ussd=routes.reduce(function (sum, tickets) {
      return sum + parseInt(tickets.ussd);
    }, 0);




      routeGroup.push({ route_name: route, total_tickets: total_tickets, amount: formatMoney(total_amount, 0) + " " + routes[0].currency,ussd:ussd,app_web:app_web,kiosk:kiosk,validator:validator,pos:pos});
  
    });

      
      console.log("res",routeGroup);

      setTotalTickets(tot_tickets);
      setTotalAmount(tot_amount);
      setReports(routeGroup);
      setReportLoad(false);

    })
    .catch(err=>{
       
        
    });
    
    }
    

  const set_interval=(token,d=null)=>{
    var reportRefresh=setInterval(()=>{
      get_branch_report(token); 
  },30000);
  }



  // format money 

  function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  
      const negativeSign = amount < 0 ? "-" : "";
  
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;
  
      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  };



  //overview detailed report 

  const [detailsMessage,setDetailsMessage]=useState("loading...")

const columns1 = [
  {
    name: "plate_nbr",
    label: "Plate Number",
    options: {
     filter: true,
     sort: true,
    }
   }
  ,
  {
    name: "departure_time",
    label: "Departure Time",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "route",
    label: "Route",
    options: {
     filter: true,
     sort: true,
    display:false
    }
   },
  {
   name: "source",
   label: "Source",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "destination",
   label: "Destination",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
    name: "total_tickets",
    label: "Total tickets",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
     name: "amount",
     label: "Total Amount",
     options: {
      filter: true,
      sort: true,
     }
    },
    {
      name: "currency",
      label: "Currency",
      options: {
       filter: true,
       sort: true,
      }
     }
 ];

 
 const options1 = {textLabels: {
  body: {
    noMatch: detailsMessage
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 100,
   elevation:0,
 };

  const [detailsDialog,setDetailsDialog]=useState(false);

  const [route,setRoute]=useState("");

  const [detailsLoad,setDetailsLoad]=useState(false);
  const [detailsReport,setDetailsReport]=useState([]);

  const get_details_report=(r)=>{
    let data={};
    if(filtering==true){
      console.log("filter");
      console.log("bus",r);
      console.log("day",day.value);
      data={
        "route":r,
        "day":day.value,
        "organization_id":new UserInfo().ORG_ID
    }
    }else{

      console.log("no filter");
      data={
        "route":r,
        "organization_id":new UserInfo().ORG_ID
    }
    }
    setDetailsReport([]);
    setDetailsMessage("Loading...");
    setDetailsDialog(true);
    setDetailsLoad(true);
    axios.defaults.baseURL = new ReportingService().BASE_URL;
    const reportInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
    reportInstance.post('/pos-report/bus-detail-report',data)
    .then(res=>{
      var objs=res.data.data;
      console.log("details",objs)
      if(objs.length){
    setDetailsMessage("No report available!");
      }
      objs.map((o)=>{
        o['amount']=formatMoney(parseInt(o['total_amount']),0)+" "+o['currency'];
      });
      setDetailsReport(objs);
      setDetailsLoad(false);
    })
    .catch(err=>{
      setDetailsLoad(false);
    });
  }



  // filter overview business

  const [filtering,setFiltering]=useState(false);

  const [filterDialog,setFilterDialog]=useState(false);
  const [filterLoad,setFilterLoad]=useState(false);
  const [filterReports,setFilterReports]=useState([]);
  const [filterTotalTickets,setFilterTotalTickets]=useState(0);
  const [filterTotalAmount,setFilterTotalAmount]=useState(0);

  const filter_report=(d)=>{
    setFiltering(true);
    setFilterLoad(true);
    axios.defaults.baseURL = new ReportingService().BASE_URL;
    const reportInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
    reportInstance.post('/pos-report/branch-detail-report',{
      // "route":"",
      // "day":d,
      // "organization_id":new UserInfo().ORG_ID,
      "start_date":d,
      "end_date":d,
      "company_id":new UserInfo().ORG_ID

  })
    .then(res=>{
      var objs=res.data.data;
      if(objs.length==0){
        setOverviewMessage("No report available!");
      }
      var totT=0;
      var totA=0;

      var groupByCurrency = groupBy(objs, function (item) {
        return [item.currency];
      });
      setGroupedByCurrency(groupByCurrency);
      console.log("filterrrrr", groupByCurrency);

      var groupByRoute = groupBy(objs, function(item) {
        return [item.route_name,item.currency];
      });

      console.log("objs",objs);

      objs.map((o)=>{
      // o['pos']=o['total_tickets'];
      // o['validator']=0;
      // o['app']=0;
      // o['kiosk']=0;
      // var t=parseInt(o['total_amount']);
      totA=totA+parseInt(o['total_income']);
      // o['total_amount']=formatMoney(t,0)+" "+o['currency'];
      totT=totT+parseInt(o['total_tickets']);
     
      });


     
  
      var routeGroup=[];
  
      groupByRoute.map((o)=>{
  
        var routes=o;
        console.log("rputes",o);
  
        var route=routes[0]['route_name'];
  
        // var currency=branches[0]['currency'];
  
        // total amount
  
      var total_amount=routes.reduce(function (sum, amount) {
          return sum + parseInt(amount.total_income);
      }, 0);
  
        // total tickets 
      var total_tickets=routes.reduce(function (sum, tickets) {
        return sum + parseInt(tickets.total_tickets);
      }, 0);
  
      var pos=routes.reduce(function (sum, tickets) {
        return sum + parseInt(tickets.pos);
      }, 0);
  
      var validator=routes.reduce(function (sum, tickets) {
        return sum + parseInt(tickets.validator);
      }, 0);
      var kiosk=routes.reduce(function (sum, tickets) {
        return sum + parseInt(tickets.kiosk);
      }, 0);
  
      var app_web=routes.reduce(function (sum, tickets) {
        return sum + parseInt(tickets.app_web);
      }, 0);
      var ussd=routes.reduce(function (sum, tickets) {
        return sum + parseInt(tickets.ussd);
      }, 0);
  
  
  
  
        routeGroup.push({ route_name: route, total_tickets: total_tickets, amount: formatMoney(total_amount, 0) + " " + routes[0].currency,ussd:ussd,app_web:app_web,kiosk:kiosk,validator:validator,pos:pos});
    
      });
  
      console.log("res",routeGroup);



      setFilterTotalTickets(totT);
      setFilterTotalAmount(totA);
      setFilterReports(routeGroup);
      setFilterLoad(false);

    })
    .catch(err=>{
      setFilterLoad(false);
    });
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <div className={classes.root}>
      <Box display="flex" mb={1} >
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}><WbIncandescentOutlined fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b>Business Overview</b></Typography>

 </Box>
 <Box mt={1}>
              <DatePicker
                fullWidth
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                autoOk
                label="Filter"
                value={day.value}
                inputVariant="outlined"
                onChange={(v)=>{
                  if(Format(v, ["yyyy-MM-dd",])!=Format(new Date(), ["yyyy-MM-dd",])){
                    setDay({value:Format(v, ["yyyy-MM-dd",]),error:""});
                    setFiltering(true);
                    filter_report(Format(v, ["yyyy-MM-dd",]));
                  }else{
                    setDay({value:Format(v, ["yyyy-MM-dd",]),error:""});
                    setFiltering(false);
                  }
                }}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              />
            </Box>
 <Box>

 <IconButton 
 onClick={()=>{
  get_branch_report(operatorData.token);
 }}
 color="primary" aria-label="add to shopping cart">
  <Cached fontSize="large"/>
</IconButton>

 {/* <Button  size="medium" color="primary" variant="outlined" startIcon={<FilterList />} onClick={()=>{
   setFilterDialog(true);
 }}>
Filter
 </Button> */}
</Box>
 
     </Box>

{filtering==false?

<Grid container spacing={1}>
            {groupedByCurrency.map((o)=>{
              return <>
                {/* total tickets  */}

                <Grid item xs={12} md={4} >
                  <Paper className={classes.paper} elevation={0}>
                    <Grid container>
                      <Grid item xs={8} md={8}>
                        <Box><Typography variant="h8" className={classes.title}>Total tickets :: {o[0]['currency']}</Typography></Box>
                        <Box mt={2}><Typography variant="h6" className={classes.title}>{o.reduce((partialSum, a) => partialSum + a.total_tickets, 0)}</Typography></Box>
                      </Grid>

                      <Grid item xs={4} md={4}>
                        <img src={iTicket} style={{ width: "80px", height: "80px" }} />
                      </Grid>

                    </Grid>
                  </Paper>
                </Grid>


                {/* total amount  */}


                <Grid item xs={12} md={4} >
                  <Paper className={classes.paper} elevation={0}>
                    <Grid container>
                      <Grid item xs={8} md={8}>
                        <Box><Typography variant="h8" className={classes.title}>Total Amount :: {o[0]['currency']}</Typography></Box>
                        <Box mt={2}><Typography variant="h6" className={classes.title}>{formatMoney(o.reduce((partialSum, a) => partialSum + a.total_income, 0) , 0)} </Typography></Box>

                      </Grid>
                      <Grid item xs={4} md={4}>
                        <AccountBalanceWalletOutlined style={{ width: "80px", height: "80px" }} color="primary" />
                      </Grid>

                    </Grid>
                  </Paper>
                </Grid>


                <Grid item xs={12} md={4} >
                  <Paper className={classes.paper} elevation={0}>
                    <Grid container>
                      <Grid item xs={8} md={8}>
                        <Box><Typography variant="h8" className={classes.title}>Channels :: {o[0]['currency']}</Typography></Box>
                        <Box mt={2}><Typography variant="h6" className={classes.title}>1</Typography></Box>
                      </Grid>
                      <Grid item xs={4} md={4}>
                        <DevicesOtherOutlined style={{ width: "80px", height: "80px" }} color="primary" />
                      </Grid>

                    </Grid>
                  </Paper>
                </Grid>

              </>
            })}

       <Grid item xs={12} sm={12} md={12} lg={12}>
 {/* overview table table  */}

 <Box mt={0}>
 {reportLoad&&<LinearProgress />}
 <MUIDataTable
  title={"Overview"}
  data={reports}
  columns={columns}
  options={options}
/>
 </Box> 
       </Grid>
     </Grid>
:

<Grid container spacing={1}>

            {groupedByCurrency.map((o) => {
              return <>
                {/* total tickets  */}

                <Grid item xs={12} md={4} >
                  <Paper className={classes.paper} elevation={0}>
                    <Grid container>
                      <Grid item xs={8} md={8}>
                        <Box><Typography variant="h8" className={classes.title}>Total tickets :: {o[0]['currency']}</Typography></Box>
                        <Box mt={2}><Typography variant="h6" className={classes.title}>{o.reduce((partialSum, a) => partialSum + a.total_tickets, 0)}</Typography></Box>
                      </Grid>

                      <Grid item xs={4} md={4}>
                        <img src={iTicket} style={{ width: "80px", height: "80px" }} />
                      </Grid>

                    </Grid>
                  </Paper>
                </Grid>


                {/* total amount  */}


                <Grid item xs={12} md={4} >
                  <Paper className={classes.paper} elevation={0}>
                    <Grid container>
                      <Grid item xs={8} md={8}>
                        <Box><Typography variant="h8" className={classes.title}>Total Amount :: {o[0]['currency']}</Typography></Box>
                        <Box mt={2}><Typography variant="h6" className={classes.title}>{formatMoney(o.reduce((partialSum, a) => partialSum + a.total_income, 0), 0)} </Typography></Box>

                      </Grid>
                      <Grid item xs={4} md={4}>
                        <AccountBalanceWalletOutlined style={{ width: "80px", height: "80px" }} color="primary" />
                      </Grid>

                    </Grid>
                  </Paper>
                </Grid>


                <Grid item xs={12} md={4} >
                  <Paper className={classes.paper} elevation={0}>
                    <Grid container>
                      <Grid item xs={8} md={8}>
                        <Box><Typography variant="h8" className={classes.title}>Channels :: {o[0]['currency']}</Typography></Box>
                        <Box mt={2}><Typography variant="h6" className={classes.title}>1</Typography></Box>
                      </Grid>
                      <Grid item xs={4} md={4}>
                        <DevicesOtherOutlined style={{ width: "80px", height: "80px" }} color="primary" />
                      </Grid>

                    </Grid>
                  </Paper>
                </Grid>

              </>
            })}


       <Grid item xs={12} sm={12} md={12} lg={12}>
 {/* overview table table  */}

 <Box mt={0}>
 {filterLoad&&<LinearProgress />}
 <MUIDataTable
  title={"Overview"}
  data={filterReports}
  columns={columns}
  options={options}
/>
 </Box> 
       </Grid>
     </Grid>



}

{/* overview details  */}


<Dialog fullScreen open={detailsDialog} style={{marginTop:"80px"}}  onClose={()=>{
   
  }} TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={()=>{
                 setDetailsDialog(false);
  }} aria-label="close">
                <Close />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                Tickets
              </Typography>
  
              <Button autoFocus color="inherit" onClick={()=>{
               setDetailsDialog(false);
  
  }}>
                Close
              </Button>
            </Toolbar>
          </AppBar>
  
          <Box mt={2}>
  {detailsLoad&&<LinearProgress />}
  <MUIDataTable
    title={route}
    data={detailsReport}
    columns={columns1}
    options={options1}
  /> 
  </Box>  
  
  </Dialog>
  


  {/* filter business overview  */}
 



<Dialog
    maxWidth="sm"
    fullWidth
        open={filterDialog}
        onClose={()=>{
            setFilterDialog(true);
        }}
        aria-labelledby="filter"
        aria-describedby="filter"
      >
        <DialogTitle id="filter">{"Filter"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>

          <Box mt={1}>
              <DatePicker
                fullWidth
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                
                autoOk
                label="Date"
                value={day.value}
                inputVariant="outlined"
                onChange={(v)=>{
                    console.log("day: ",v);
                    setDay({value:Format(v, ["yyyy-MM-dd",]),error:""});
                }}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              />
            </Box>

          </Box>
         </DialogContentText>
         </DialogContent>

         <DialogActions>
         
          <Button onClick={()=>{
              setFilterDialog(false);
          }} color="secondary" className={classes.btn}>
            <Typography>Close</Typography>
          </Button>


            
          <Button onClick={()=>{

            filter_report();

          }} color="primary" variant="contained" className={classes.btn}>
              {reportLoad?<CircularProgress size={25} color="secondary"/>:
              <Typography>View</Typography>
              }
          </Button>


        </DialogActions>
         </Dialog>




    </div>
    </MuiPickersUtilsProvider>
  );
}

export default  withLocalize(BusinessOverview);